import { GET_ORG_GENERAL_SETTINGS, UPDATE_ORG_GENERAL_SETTINGS } from '../../types'
import { trackPromise } from 'react-promise-tracker'
import log from 'loglevel'
import { parseResponse } from '@jweb-development/response-parser'
import { loadingAreas } from '../../../utils/variables'
const isOnPrem = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true')
const api = isOnPrem && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : isOnPrem && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const getOrgGeneralSettings = () => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }
    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}`, options))

    if (!response.status || response.status === 401 || response.status === 500) {
      log.warn('non 200 status code from accounts')
    } else {
      const { data } = await response.json()
      const orgSettings = {
        accountName: data.accountName,
        address: data.address,
        address2: data.address2,
        city: data.city,
        state: data.state,
        postalCode: data.postalCode,
        timeZone: data.timeZone,
        primaryColor: data.primaryColor,
        secondaryColor: data.secondaryColor,
        imageKey: data.imageKey,
        imagePath: isOnPrem && window.location.protocol === 'http:' ? `http://${window.location.hostname}/${data.imagePath}` : isOnPrem && window.location.protocol === 'https:' ? `https://${window.location.hostname}/${data.imagePath}` : data.imagePath
      }

      // console.log(JSON.stringify(data, null, 2))

      dispatch({
        type: GET_ORG_GENERAL_SETTINGS,
        payload: orgSettings
      })
    }
  }
}

export const updateOrgGeneralSettings = (settings, fireSuccess = () => { }, fireFailure = () => { }) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const body = { ...settings }

    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/general`, options))

    if (!response.status || response.status === 401 || response.status === 500 || response.status === 400 || response.status === 404) {
      log.warn('non 200 status code from account general settings')
      fireFailure()
    } else {
      const orgSettings = { ...settings }
      dispatch({
        type: UPDATE_ORG_GENERAL_SETTINGS,
        payload: orgSettings
      })
      fireSuccess()
    }
  }
}

export const updateAccountImage = (image, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth
    const accountID = accountId

    const body = { image }

    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountID}/accountimage`, options))

    if (!response.status || response.status === 400 || response.status === 401 || response.status === 404 || response.status === 413 || response.status === 500) {
      fireFailure()
    } else {
      fireSuccess()
    }
  }
}

export const fetchAccountSupportKey = (fireSuccess = () => {}, fireFailure = () => {}) => {
  return async (dispatch, getState) => {
    try {
      const { token, accountId } = getState().auth

      const options = {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }

      const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/support/key`, options), loadingAreas.FETCH_SUPPORT_KEY)
      const parsedResponse = parseResponse(response)

      if (parsedResponse && !parsedResponse.error) {
        const { data } = await response.json()

        return fireSuccess(data?.dailyKey)
      }

      return fireFailure()
    } catch (err) {
      console.error(err)
      fireFailure()
      return false
    }
  }
}
